import { Route, Redirect } from 'react-router-dom';
import App from 'components/layouts/App';

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return rest.authenticated ? (
          rest.app ? (
            <App title={rest.title} appClass={rest.appClass}>
              <Component {...props} />
            </App>
          ) : (
            <Component {...props} />
          )
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
